<ion-icon
  [name]="'arrow-back-outline'"
  class="{{
    appearance()
  }} text-xl p-2 backdrop-blur-sm rounded-full cursor-pointer"
  (click)="navigateBack()"
/>
